module.exports = __webpack_public_path__ + "static/media/Doduo_gaussian2.795b743c.png";